import React from "react";
import { BalanceGrowthIcon, GrowthIcon, LossIcon } from "../../constant";
import { formatNumberWithCommas } from "../../helpers";
import classes from "./PaymentStatsCard.module.css";
import clsx from "clsx";

const renderRelevantIcon = (percentage) => {
  if (percentage === 0) {
    return <BalanceGrowthIcon />;
  } else if (percentage < 0) {
    return <LossIcon />;
  } else {
    return <GrowthIcon />;
  }
};
const PaymentStatusCard = ({ number, title, icon, percentage,period }) => {
 console.log("period == >>",period)
  return (
    <div className={classes.wrapper}>
      <div className={classes.iconContainer}>
        {icon}
        <div className={classes.textContainer}>
          <h3> {number && formatNumberWithCommas(number)} </h3>
          <p>{title}</p>
        </div>
      </div>
      {!isNaN(percentage) && (
        <div className={classes.growthContainer}>
          <span className={classes.growthValue}>
            {renderRelevantIcon(percentage)}
            <span
              className={clsx(classes.growthValue, {
                [classes.green]: percentage > 0,
                [classes.red]: percentage < 0,
                [classes.blue]: percentage === 0,
              })}
            >
              {`${Math.abs(percentage)?.toFixed(0)}%`}
            </span>
          </span>
          <span className={classes.duration}>vs Last {period} Days</span>
          {/* <LossIcon /> */}
        </div>
      )}
    </div>
  );
};

export default PaymentStatusCard;
